import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function useAdLock() {
  const { user } = useAuth();
  const [locked, setLocked] = useState(false);
  const free = user && user.tier !== "premium";

  useEffect(() => {
    if (!free) return;
    api.get("/ads/status").then(({ data }) => setLocked(data.locked)).catch(() => {});
  }, [free, user?.id]);

  return { adLocked: free && locked, setAdLocked: setLocked };
}
